import { render, staticRenderFns } from "./charcolor.vue?vue&type=template&id=c58d11e4&scoped=true"
import script from "./charcolor.vue?vue&type=script&lang=js"
export * from "./charcolor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58d11e4",
  null
  
)

export default component.exports